import React from "react";
import Strings from "@my-dld/assets/strings";

export default function FormMandatory() {
	return <div className="mandatory-field-info">
		<small>{ Strings.mandatory_fields_note }</small>
	</div>;
}
